module.exports = __webpack_public_path__ + "static/media/tick-mark.56e309c1.svg";